var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.5095C20 21.04 19.7893 21.5487 19.4142 21.9237C19.0391 22.2988 18.5304 22.5095 18 22.5095H6C5.46957 22.5095 4.96086 22.2988 4.58579 21.9237C4.21071 21.5487 4 21.04 4 20.5095V4.50952C4 3.97909 4.21071 3.47038 4.58579 3.09531C4.96086 2.72024 5.46957 2.50952 6 2.50952H14L20 8.50952V10.0296",
    stroke: "#01295F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.50952V8.50952H20",
    stroke: "#01295F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1357 18.3242L22.0867 15.3733L19.1357 12.4223",
    stroke: "#01295F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0867 15.3733L22.0867 15.3733",
    stroke: "#01295F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvert);
export default __webpack_public_path__ + "static/media/Convert.a61ae96412d8a7fc8d9a1e699b340db0.svg";
export { ForwardRef as ReactComponent };